import styled from 'styled-components';

import {
  Content as ModalContent,
  Header as ModalHeader,
  Title as ModalTitle,
} from '~/components/Modal/styles';
import grid from '~/styles/grid';

export const ButtonContainer = styled.div`
  button {
    padding: 0 ${grid.sm};
    width: 60px;
    height: 30px;

    &:disabled {
      border: none;
      border-color: transparent;
    }
  }
`;

export const ButtonIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: ${grid.sm};
`;

export const SelectManyContainer = styled.div`
  div {
    display: flex;
    align-items: center;
    column-gap: ${grid.md};
    cursor: pointer;
    margin: 0 ${grid.sm} ${grid.sm} 0;
    padding-bottom: ${grid.sm};
    &:hover {
      color: black;
    }
    height: 48px;

    button {
      background: transparent;
      border: none;
      font-size: 16px;
    }
  }

  div:nth-child(1) {
    border-bottom: 2px solid #e6e6e6;
  }
`;

export const ModalContainer = styled.div`
  ${ModalContent} {
    padding: ${grid.lg};
    max-height: 300px;
  }

  ${ModalHeader} {
    font-weight: 600;
    color: #4d4d4d;
    margin-bottom: ${grid.xl};
    text-align: center;

    &::after {
      display: none;
    }
  }

  ${ModalTitle} {
    font-size: 18px;
    font-weight: bold;
    padding: 0;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
